export enum FocusModeMacroResolutionStatus {
  Success = 'success',
  NotFound = 'not_found',
  NonMacro = 'non_macro',
  Error = 'error',
}
